import { Notes } from 'components/Notes'
import { httpDelete, httpGet, httpPost, httpPut } from 'lib/http'
import { setBanner, setLoad, setUnload } from 'lib/notification/actions'

import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import formatters from 'lib/formatters'
import MainCtaFooter from '../../Distributions/components/Footer/MainCtaFooter.js'
import ReviewForm from '../../Distributions/components/Main/forms/ReviewForm.js'
import ActionsNeeded from '../../Distributions/components/Footer/ActionsNeeded.js'
import styles from '../../Distributions/components/Main/styles.css'
import CheckForm from './CheckForm.js'
import DirectDepositForm from './DirectDepositForm.js'
import DepositView from './view/DepositView.js'
import Header from '../Received/Header.js'
import RequestDocument from '../../Distributions/components/Main/forms/RequestDocument.js'
import { Dialog } from 'components/Dialog'
import { getQueueUrlForStatus } from './depositUtils.js'
import { Loader } from 'components/Notifications'

const DepositsMain = () => {
  const params = useParams()
  const navigate = useNavigate()

  const id = params.id
  const dispatch = useDispatch()

  const requiredActions = () => {
    return form.required_actions || []
  }

  const [formInit, setFormInit] = useState(null)
  const [form, setForm] = useState({
    beneficiary: '',
    account: {
      id: null,
      number: '',
      beneficiary: '',
      journal_name: '',
      floor_amount: 0,
      has_budget: false,
    },
    trust_account: null,
    amount: '',
    bank_date: '',
    deposit_type: 'check',
    is_refund: null,
    is_transfer: null,
    take_enrollment_fee: null,
    deposit_to_cash: false,
    deposited_bank_account: '',
    cash_account: '',
    fee_exceptions: '',
    schedule: '',
    admin_fee: '',
    fee_rate: '',
    enroll_fee: '',
    owner: '',
    deposit_id: '',

    inserted_at: '',
    copied_from_date: '',
    last_updated_date: '',
    last_updated_user: '',
    copied_to_id: null,
    copied_from_id: null,
    notes: [],
    events: [],
    files: [],
    accountContacts: [],
    otherDistributions: {
      open: [],
      pending: [],
      paid: [],
      openTotal: 0,
      pendingTotal: 0,
      paidTotal: 0,
    },
    recurringDistribution: {
      scheduledDistributions: [],
    },
    wire_reference: '',
    sending_bank: '',
    routing_number: '',
    sender_account: '',
    check_number: '',
    bank_name: '',
    check_date: '',
    memo: '',
    ach_reference: '',
    originating_bank: '',
    ach_routing: '',
    originating_account: '',
    recurring_setup: '',
    note: '',
    fee_amount: null,
    balance_snapshot_at: null,
    enrollment_fee_amount: null,
    calculated_enrollment_fee_amount: null,
    fee_schedule: null,
    main_balance_snapshot: null,
    subaccounts_balance_snapshot: null,
    total_balance_snapshot: null,
    xeroLink: '',
    xeroTransferReceiveLink: '',
    xeroTransferSpendLink: '',
    xeroCashSpendLink: '',
    required_actions: [],
  })

  const [files, setFiles] = useState([])
  const [formDisabled, setFormDisabled] = useState(false)
  const [currentStatus, setCurrentStatus] = useState('')
  const [nextStatus, setNextStatus] = useState('')
  const [events, setEvents] = useState([])
  const [lockedForEdit, setLockedForEdit] = useState(null)
  const [approveButtonText, setApproveButtonText] = useState('Save')
  const [disapproveButtonText, setDisapproveButtonText] = useState('Delete')
  const [showUnableToProcess, setShowUnableToProcess] = useState(false)
  const [checkingBalance, setCheckingBalance] = useState('')
  const [hasDepositTypeFromAPI, setHasDepositTypeFromAPI] = useState(false)
  const [isOver65SSI, setIsOver65SSI] = useState(false)
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [completedActions, setCompletedActions] = useState([])
  const [edit, setEdit] = useState(true)
  const [stepper, setStepper] = useState({
    title: 'Receive',
    subheader: 'Deposit',
    stepper: {
      steps: null,
      activeStep: 0,
    },
    id: id,
    idTitle: 'DEPOSIT ID',
  })

  const updateForm = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const getHeader = ({ currentStatus, id }) => {
    const steps = [{ label: 'Begin Deposit' }, { label: 'Review' }, { label: 'Approve Deposit' }]

    const activeStep = steps.findIndex((step, index) => {
      switch (currentStatus) {
        case 'received':
        case 'quick_deposited':
          return index === 0
        case 'reviewed':
        case 'transferred':
          return index === 1
        case 'deposited':
        case 'approved':
          return index === 2
        default:
          return index === 0
      }
    })

    return {
      title: 'Receive',
      subheader: 'Deposit',
      stepper: {
        steps: steps,
        activeStep: activeStep >= 0 ? activeStep : 0,
      },
      id: id,
      idTitle: 'DEPOSIT ID',
    }
  }

  const setStatusBasedTexts = (nextStatus, status) => {
    if (nextStatus === 'reviewed' || nextStatus === 'reviewed_with_approved_edits') {
      setApproveButtonText('Make Deposit')
    } else {
      setApproveButtonText('Save')
    }

    setDisapproveButtonText('Delete')

    if (isSaveRequired()) {
      if (nextStatus === 'reviewed' || nextStatus === 'reviewed_with_approved_edits') {
        setApproveButtonText('Make Deposit')
      } else {
        setApproveButtonText('Save')
      }
    }
  }

  const isMainQueue = (nextStatus) => {
    return ['received', 'quick_deposited', 'transferred', 'reviewed'].includes(nextStatus)
  }

  const denied = ['cancelled', 'denied', 'failed']

  const fetchData = (id) => {
    if (!id) {
      dispatch(setBanner('Invalid deposit ID', 'danger'))
      navigate('/deposits')
      return
    }

    dispatch(setLoad())
    setIsLoading(true)

    httpGet(`/admin/deposits/${id}`)
      .then((response) => {
        let deposit = null

        if (response && response.data && response.data.deposit) {
          deposit = response.data.deposit
        } else if (response && response.deposit) {
          deposit = response.deposit
        } else if (response && response.id && typeof response.id === 'number') {
          deposit = response
        } else if (response && response.data && response.data.id) {
          deposit = response.data
        } else if (Array.isArray(response) && response.length > 0 && response[0].id) {
          deposit = response[0]
        }

        if (!deposit || !deposit.id) {
          throw new Error(`No valid deposit data found in API response. Expected deposit with ID ${id}`)
        }

        if (deposit.id !== parseInt(id)) {
          throw new Error(`Deposit ID mismatch. Expected ${id}, got ${deposit.id}`)
        }

        setEvents(deposit?.events || [])

        const hasDepositTypeFromAPI = Boolean(deposit.deposit_type && deposit.deposit_type.trim() !== '')
        setHasDepositTypeFromAPI(hasDepositTypeFromAPI)

        const isCashDeposit = Boolean(deposit.cash_account && deposit.cash_account.trim() !== '')

        const isLockedForEdit = Boolean(deposit.locked_for_edit === true || deposit.lockedForEdit === true)
        setLockedForEdit(isLockedForEdit)

        setCompletedActions(deposit.completed_actions)
        setIsOver65SSI(deposit.isOver65SSI || false)

        const formData = {
          deposit_id: deposit.id,

          amount: deposit.amount || '',
          deposit_type: deposit.deposit_type || 'check',
          is_refund: deposit.is_refund,
          is_transfer: deposit.is_transfer,
          take_enrollment_fee: deposit.take_enrollment_fee,

          deposit_to_cash: isCashDeposit,

          deposited_bank_account: deposit.deposited_bank_account || '',
          receiving_bank_account: deposit.receiving_bank_account || '',
          cash_account: deposit.cash_account || '',

          inserted_at: deposit.inserted_at || '',
          copied_from_date: deposit.copied_from_date || '',
          last_updated_date: deposit.last_updated_date || '',
          last_updated_user: deposit.last_updated_user || '',

          xeroLink: deposit.xero_link || '',
          xeroTransferReceiveLink: deposit.xero_transfer_receive_link || '',
          xeroTransferSpendLink: deposit.xero_transfer_spend_link || '',
          xeroCashSpendLink: deposit.xero_cash_spend_link || '',
          copied_to_id: deposit.copied_to_id || null,
          copied_from_id: deposit.copied_from_id || null,
          account: isCashDeposit
            ? {
                id: null,
                number: '',
                beneficiary: '',
                journal_name: '',
                floor_amount: 0,
                has_budget: false,
              }
            : {
                id: deposit.account?.id || null,
                number: deposit.account?.number || '',
                beneficiary: deposit.account?.beneficiary || '',
                journal_name: deposit.account?.journal_name || '',
                floor_amount: deposit.account?.floor_amount || 0,
                has_budget: deposit.account?.has_budget || false,
              },

          trust_account: isCashDeposit
            ? null
            : deposit.account
            ? {
                id: deposit.account.id,
                number: deposit.account.number,
                beneficiary: deposit.account.beneficiary,
                journal_name: deposit.account.journal_name,
                floor_amount: deposit.account.floor_amount,
                has_budget: deposit.account.has_budget,
              }
            : null,

          beneficiary: deposit.account?.beneficiary || '',
          bank_date: deposit.bank_date,
          client_date: deposit.client_date || '',

          fee_exceptions: deposit.fee_exceptions || false,
          schedule: deposit.schedule || '',
          admin_fee: deposit.admin_fee || '',
          fee_rate: deposit.fee_rate || '',
          enroll_fee: deposit.enroll_fee || '',
          owner: deposit.owner || '',

          fee_amount: deposit.fee_amount || null,
          balance_snapshot_at: deposit.balance_snapshot_at || null,
          enrollment_fee_amount: deposit.enrollment_fee_amount || null,
          calculated_enrollment_fee_amount: deposit.calculated_enrollment_fee_amount || null,
          fee_schedule: deposit.fee_schedule || null,
          main_balance_snapshot: deposit.main_balance_snapshot || null,
          subaccounts_balance_snapshot: deposit.subaccounts_balance_snapshot || null,
          total_balance_snapshot: deposit.total_balance_snapshot || null,

          wire_reference: deposit.wire_reference || '',
          sending_bank: deposit.sending_bank || '',
          routing_number: deposit.routing_number || '',
          sender_account: deposit.sender_account || '',

          check_number: deposit.check_number || '',
          bank_name: deposit.bank_name || '',
          check_date: deposit.check_date || '',
          memo: deposit.memo || '',

          ach_reference: deposit.ach_reference || '',
          originating_bank: deposit.originating_bank || '',
          ach_routing: deposit.ach_routing || '',
          originating_account: deposit.originating_account || '',
          recurring_setup: deposit.recurring_setup || '',

          note: deposit.note || '',

          notes: deposit.notes || [],
          events: deposit.events || [],
          files: deposit.files || [],
          accountContacts: deposit.accountContacts || [],
          otherDistributions: {
            open: deposit.otherDistributions?.open || [],
            pending: deposit.otherDistributions?.pending || [],
            paid: deposit.otherDistributions?.paid || [],
            openTotal: deposit.otherDistributions?.openTotal || 0,
            pendingTotal: deposit.otherDistributions?.pendingTotal || 0,
            paidTotal: deposit.otherDistributions?.paidTotal || 0,
          },
          recurringDistribution: {
            scheduledDistributions: deposit.recurringDistribution?.scheduledDistributions || [],
          },
          required_actions: deposit.required_actions || [],
        }

        setForm(formData)
        setFormInit(formData)
        setCurrentStatus(deposit.status || 'new')
        setNextStatus(deposit.next_status || '')
        setFiles(deposit.files || [])

        const formDisabledState = ['deposited', 'cancelled', 'approved'].includes(deposit.status) || isLockedForEdit
        setFormDisabled(formDisabledState)

        setStatusBasedTexts(deposit.next_status || 'received', deposit.status)

        if (['reviewed', 'reviewed_with_approved_edits'].includes(deposit.next_status)) {
          setEdit(false)
        } else {
          setEdit(true)
        }

        setIsLoading(false)
        dispatch(setUnload())
      })
      .catch((err) => {
        let errorMessage = 'Something went wrong... Please try again later'

        if (err?.status === 404) {
          errorMessage = `Deposit with ID ${id} not found`
        } else if (err?.status === 500) {
          errorMessage = `Server error while fetching deposit ${id}. Please contact support if this persists.`
        } else if (err?.message) {
          errorMessage = err.message
        }

        setIsLoading(false)
        navigate('/deposits')
        dispatch(setBanner(errorMessage, 'danger'))
        dispatch(setUnload())
      })
  }

  const doUpdate = (statusArg) => {
    const url = `/admin/deposits/${id}`

    const hasValidTrustAccount = form.trust_account && form.trust_account.id && form.trust_account.number && !form.deposit_to_cash

    const params = {
      amount: form.amount,
      deposit_type: form.deposit_type,
      bank_date: form.bank_date,
      is_refund: form.is_refund,
      is_transfer: form.is_transfer,
      take_enrollment_fee: form.take_enrollment_fee,
      deposit_to_cash: form.deposit_to_cash,

      last_updated_user: 'Current User',
      completed_actions: completedActions,

      ...(hasValidTrustAccount && {
        account_id: form.trust_account.id,
        account_number: form.trust_account.number,
      }),

      ...(form.cash_account && {
        cash_account: form.cash_account,
      }),

      ...(form.deposited_bank_account && {
        deposited_bank_account: form.deposited_bank_account,
      }),

      ...(form.fee_exceptions && { fee_exceptions: form.fee_exceptions }),
      ...(form.schedule && { schedule: form.schedule }),
      ...(form.admin_fee && { admin_fee: form.admin_fee }),
      ...(form.fee_rate && { fee_rate: form.fee_rate }),
      ...(form.enroll_fee && { enroll_fee: form.enroll_fee }),
      ...(form.owner && { owner: form.owner }),

      ...(form.deposit_type === 'wire' && {
        wire_reference: form.wire_reference,
        sending_bank: form.sending_bank,
        routing_number: form.routing_number,
        sender_account: form.sender_account,
      }),

      ...(form.deposit_type === 'check' && {
        check_number: form.check_number,
        bank_name: form.bank_name,
        check_date: form.check_date,
        memo: form.memo,
      }),

      ...(form.deposit_type === 'direct_deposit' && {
        ach_reference: form.ach_reference,
        originating_bank: form.originating_bank,
        ach_routing: form.ach_routing,
        originating_account: form.originating_account,
        recurring_setup: form.recurring_setup,
      }),

      ...(form.note && { note: form.note }),
    }

    dispatch(setLoad())

    httpPut(url, params)
      .then(({ deposit }) => {
        const friendlyStatus = formatters.legibleDepositStatus(deposit.status, deposit.next_status).toUpperCase().replace('_', ' ')
        dispatch(setBanner(`Deposit ID ${deposit.id} saved in ${friendlyStatus}`))
        dispatch(setUnload())

        const updatedStatus = deposit.status
        const updatedNextStatus = deposit.next_status

        setCurrentStatus(updatedStatus)
        setNextStatus(updatedNextStatus)

        if (
          updatedNextStatus === 'reviewed' ||
          updatedNextStatus === 'reviewed_with_approved_edits' ||
          updatedStatus === 'deposited' ||
          updatedStatus === 'cash'
        ) {
          const queueUrl =
            updatedNextStatus === 'reviewed_with_approved_edits'
              ? getQueueUrlForStatus('reviewed_with_approved_edits')
              : getQueueUrlForStatus('reviewed')
          navigate(queueUrl)
        } else {
          fetchData(id)
        }
      })
      .catch((err) => {
        dispatch(setBanner(`Error saving deposit - ${err}`, 'danger'))
        dispatch(setUnload())
      })
  }

  const handleMoveToClientAccount = () => {
    const url = `/admin/deposits/${id}/copy`

    dispatch(setLoad())

    httpPut(url)
      .then((response) => {
        let newDepositId = null

        if (response?.data?.id) {
          newDepositId = response.data.id
        } else if (response?.id) {
          newDepositId = response.id
        } else if (response?.data?.deposit?.id) {
          newDepositId = response.data.deposit.id
        }

        if (newDepositId) {
          dispatch(setBanner(`Deposit moved to ID ${newDepositId}`, 'success'))
          dispatch(setUnload())
          navigate(`/deposits/${newDepositId}`)
        } else {
          dispatch(setBanner('Deposit copied successfully', 'success'))
          dispatch(setUnload())
          fetchData(id)
        }
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message || err?.message || 'Error copying deposit'
        dispatch(setBanner(errorMessage, 'danger'))
        dispatch(setUnload())
      })
  }

  const buildUploadParams = async (fileName, file) => {
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })

    const data = await toBase64(file)
    return {
      content_type: file.type,
      name: fileName,
      data: data.split(',')[1],
    }
  }

  const onUploadClick = (fileName, file) => {
    buildUploadParams(fileName, file).then((params) => {
      const url = `/admin/deposits/${id}/files`

      dispatch(setLoad())

      httpPost(url, params)
        .then((data) => {
          dispatch(setBanner('File uploaded'))
          setFiles(data.files)
          dispatch(setUnload())
        })
        .catch((err) => {
          dispatch(setBanner(`Error saving - ${err}`, 'danger'))
          dispatch(setUnload())
        })
    })
  }

  const onDeleteClick = (fileId) => {
    const url = `/admin/deposits/files/${fileId}`

    httpDelete(url)
      .then((res) => {
        setFiles(files.filter((file) => file.id !== fileId))
        dispatch(setBanner('File deleted'))
      })
      .catch((err) => {
        dispatch(setBanner(`Error deleting - ${err}`, 'danger'))
      })
  }

  const isSaveRequired = () => {
    return true
  }

  const validateCheckDepositForSave = () => {
    // Check if this is a check deposit with next_status = 'received'
    if (form.deposit_type === 'check' && nextStatus === 'received') {
      const missingFields = []

      if (form.is_transfer === null || form.is_transfer === undefined) {
        missingFields.push('investment transfer')
      }
      if (form.is_refund === null || form.is_refund === undefined) {
        missingFields.push('refund')
      }

      if (missingFields.length > 0) {
        const fieldText = missingFields.join(' or ')
        return {
          isValid: false,
          message: `Please answer whether this is a ${fieldText} before saving`,
        }
      }
    }

    return { isValid: true }
  }

  const handleConfirmationConfirm = (event) => {
    event?.preventDefault()

    if (lockedForEdit) {
      dispatch(setBanner('Cannot update deposit - locked for editing', 'danger'))
      return
    }

    const validation = validateCheckDepositForSave()
    if (!validation.isValid) {
      dispatch(setBanner(validation.message, 'danger'))
      return
    }

    doUpdate()
  }

  const handleDisapprove = () => {
    setShowDeleteConfirmation(true)
  }

  const handleDeleteConfirm = () => {
    const url = `/admin/deposits/${id}`

    dispatch(setLoad())

    httpDelete(url)
      .then((response) => {
        dispatch(setBanner('Deposit successfully deleted'))
        dispatch(setUnload())
        setShowDeleteConfirmation(false)

        const deletedQueueUrl = getQueueUrlForStatus('deleted')
        navigate(deletedQueueUrl)
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message || err?.message || 'Error deleting deposit'
        dispatch(setBanner(errorMessage, 'danger'))
        dispatch(setUnload())
        setShowDeleteConfirmation(false)
      })
  }

  const handleDeleteCancel = () => {
    setShowDeleteConfirmation(false)
  }

  const hasFeeDataFromAPI =
    !isLoading &&
    (form.fee_amount !== null ||
      form.fee_schedule !== null ||
      form.enrollment_fee_amount !== null ||
      form.calculated_enrollment_fee_amount !== null ||
      form.total_balance_snapshot !== null ||
      form.balance_snapshot_at !== null)

  const formProps = {
    onUploadClick,
    files,
    onDeleteClick,
    form,
    updateForm,
    formDisabled,
    nextStatus,
    lockedForEdit,
    depositId: id,
    shouldShowNote: false,
    hasDepositTypeFromAPI,
    setEdit,
    currentStatus,
    ...(hasFeeDataFromAPI && {
      initialFeeData: {
        fee_amount: form.fee_amount,
        balance_snapshot_at: form.balance_snapshot_at,
        enrollment_fee_amount: form.enrollment_fee_amount,
        calculated_enrollment_fee_amount: form.calculated_enrollment_fee_amount,
        fee_rate: form.fee_rate,
        fee_schedule: form.fee_schedule,
        main_balance_snapshot: form.main_balance_snapshot,
        subaccounts_balance_snapshot: form.subaccounts_balance_snapshot,
        total_balance_snapshot: form.total_balance_snapshot,
      },
    }),
  }

  const depositViewProps = {
    files,
    form,
    edit,
    setEdit,
  }

  const ctaFormProps = {
    form,
    formDisabled,
    disapproveButtonText,
    approveButtonText,
    disapproveButtonVariant: 'delete',
    files,
    nextStatus,
    handleConfirmationConfirm,
    handleDisapprove,
    setShowUnableToProcess,
    isSaveRequired,
    lockedForEdit,
    showUnableToProcess,
    setShowUnableToProcess,
    showOnlyApproveButton: false,
    handleMoveToClientAccount: currentStatus === 'cash' && !form.copied_to_id ? handleMoveToClientAccount : null,
    showMoveToClientButton: currentStatus === 'cash' && !form.copied_to_id,
  }

  const renderDepositForm = () => {
    if (isLoading) {
      return <Loader non_redux_loading={true} />
    }

    if (!edit) {
      return (
        <div className={styles.contentContainer} style={{ display: 'block' }}>
          <div style={{ marginBottom: '20px', width: '100%' }}>
            <DepositView {...depositViewProps} />
          </div>
          <div style={{ width: '66.5%' }}>
            <RequestDocument {...formProps} />
          </div>
        </div>
      )
    }

    switch (form.deposit_type) {
      case 'wire':
        return <DirectDepositForm {...formProps} />
      case 'check':
        return <CheckForm {...formProps} />
      case 'direct_deposit':
        return <DirectDepositForm {...formProps} />
      default:
        return <CheckForm {...formProps} />
    }
  }

  useEffect(() => {
    setStatusBasedTexts(nextStatus, form.status)
  }, [form, formInit, nextStatus, completedActions])

  useEffect(() => {
    fetchData(id)
  }, [id])

  useEffect(() => {
    isSaveRequired()
  }, [form, formInit, completedActions])

  useEffect(() => {
    const headerStepper = getHeader({
      currentStatus,
      id,
    })
    setStepper(headerStepper)
  }, [currentStatus, id])

  if (isLoading) {
    return <Loader non_redux_loading={true} />
  }

  return (
    <>
      <div className={styles.contentContainer}>
        <Header
          title="DEPOSIT"
          status={formatters.legibleDepositStatus(currentStatus, nextStatus)}
          statusLabel="Current Status:"
          id={id}
          lockedForEdit={lockedForEdit}
        />
      </div>
      <form className={styles.form}>
        {renderDepositForm()}
        <ReviewForm
          form={{
            ...form,
            notes: form.notes || [],
            events: form.events || [],
            files: files || [],
          }}
          checkingBalance={checkingBalance}
          setCheckingBalance={setCheckingBalance}
          formDisabled={formDisabled}
          isOver65SSI={isOver65SSI}
          showFeeSchedule={true}
          showNotes={true}
        />
      </form>

      <div className={styles.footerContainer}>
        <div className={styles.notesList}>
          <Notes depositId={id} dispatch={dispatch} notes={form.notes} type="deposit" />

          {requiredActions().length > 0 && (
            <ActionsNeeded
              completedActions={completedActions}
              requiredActions={requiredActions()}
              setCompletedActions={setCompletedActions}
              checkColor={isMainQueue(nextStatus) ? 'green' : 'red'}
              sectionTitle={denied.includes(currentStatus) ? 'Closing Actions' : null}
            />
          )}
          {isOver65SSI && <div className={styles.orange}>Beneficiary is on SSI and over 65 years old</div>}
        </div>
        <MainCtaFooter {...ctaFormProps} />
      </div>

      {showDeleteConfirmation && (
        <Dialog
          cancelButtonText="Cancel"
          confirmButtonText="Yes, Delete"
          headerText="Are you sure you want to delete this deposit?"
          onCancel={handleDeleteCancel}
          onConfirm={handleDeleteConfirm}
        />
      )}
    </>
  )
}

export default DepositsMain
